<template>
  <div class="about_box">
    <div class="banner">
      <div class="top">
        <div class="title">关于我们</div>
        <div class="titleSc">About us</div>
      </div>
      <img class="bannerimg" :src="$baseUrl + img_src.banner" alt="banner" />
    </div>
    <!-- <div class="type">
      <span class="type_item" v-for="(item, index) in typeList" :key="index"
        :class="current_type === index ? 'typeActive' : ''" @click="checkoutType(index)">
        {{ item.title }}
    </span>-->
    <!-- </div> -->
    <typebutton :current_type="current_type" :typeList="typeList" @checkType="checkType($event)"></typebutton>
    <!-- 内容 -->
    <div class="about_content">
      <!-- 公司介绍 -->
      <div class="introduce" v-if="current_type == 0">
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;江西玉鸿图大数据发展有限公司是一家高端医疗产品综合服务商：集医疗信息系统集成；产品研发、生产、销售和服务为一体的高科技技术企业。公司提供专业的个性化医疗解决方案为医院体检中心、智慧药房、基层医疗、健康小屋、智慧养老、社区养老、康养小镇等项目提供相应的“一站式”服务。并根据国家公共卫生平台和智慧健康养老的内容提供定制化的解决方案。
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公卫体检硬件设备包含：便携式随访包、健康检测一体机以及健康体检车等大、小型设备。可通过硬件设备快速采集患者的生命体征参数、自助建立居民档案及管理、实现社区首诊、分级诊疗、双向转诊的诊疗新模式，包括医生签约、智慧医生平台的建设（包括软件系统的研发）、远程会诊、远程医疗语音系统等，解决医疗资源配置不均衡的问题，让患者享受到方便、快速、均等的医疗服务。
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们始终秉承着为客户提供最好的产品、良好的技术支持、健全的售后服务为宗旨。励志成为医疗健康产业的领先企业，为人类健康做出卓越贡献，致力于向全球医疗机构和家庭提供优质的个性解决方案、智能化医疗健康产品和服务。
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;玉鸿图科技致力于构建多层次的健康服务体系，线上线下主推两大核心产品：数字健康云平台、慢病自助管理中心，在慢病管理领域，成为行业的领导者。
        </p>
        <p class="title">线上：数字健康管理云平台为公司核心产品</p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数字健康管理云平台是基于云端的灵活可配置的健康数字化管理服务平台，具备四大端口、双向转诊、互通共享的核心优势。平台实现了服务与管理的融合，达到了多方面健康数据的整合与梳理，是纯粹的“健康数据生产系统平台”。实时准确的数据，便于医生团队实时监管居民健康状况，使医院实现无纸化办公，便于卫健委为人民群众提供全方位全周期健康服务，为健康中国2030赋能。
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在健康行业的快速发展中，平台的完善有助于减轻基层医务人员的工作负担，卫健部门对居民健康进行有效监管，提高居民健康知识及意识习惯。而形成一个良性的健康自我监测、管理、促进的循环体系。对异常情况早发现，早预防，早治疗。长期的健康监护以及健康指导，可以帮助慢性病患者提高健康意识，形成良好的生活习惯，使病情可控、并逐渐好转，实现全民健康化。
        </p>
        <p class="title">
          线下：构建预防为主、防治结合、以基层为重点的数字健康管理体系
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;构建预防为主、防治结合、以基层为重点的数字健康管理体系，是玉鸿图科技一直践行的方向。
          在社区卫生服务中心设立一个大型的健康自助管理中心，社区卫生服务站设立小型健康自助管理中心辐射整个区域居民，提供专业、个性化健康管理服务。健康自助管理中心放置自助体检设备，为居民提供自助体检服务。居民自助体检完后，当场可以查看相关体检报告及健康指数解读。提供系统连续的预防、治疗、康复、健康促进一体化服务，提升健康服务的公平性、可及性、有效性，实现早诊早治早康复。
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;玉鸿图科技坚持预防为主、防治结合的原则，以基层为重点。利用信息化平台及健康自助管理中心，实现居民体检数据互联互通，可以根据不同人群的需求，提供专业、个性化的健康服务。
        </p>
        <img :src="$baseUrl + img_src.contentbg" width="900px" height="426px" alt
          style="margin-top: 70px; margin-bottom: 70px" />
      </div>
      <!-- 资质 -->
      <div class="intelligence" v-if="current_type == 1">
        <tr>
          <td v-for="(item, index) in intelligenceTitleList" :key="'intelligenceTitle' + index">
            <div class="intelligenceTitle">
              <div class="div-num">
                <div class="num">{{ item.num }}</div>
                <div class="unit">项</div>
              </div>
              <div class="intelligencetitle">{{ item.title }}</div>
            </div>
          </td>
        </tr>
        <tr style="margin-top: 60px">
          <td v-for="(item, index) in certificates_img_src1" :key="'certificates_img_src1' + index">
            <div class="certificates_img">
              <img :src="$baseUrl + item" alt width="171px" height="243px" />
            </div>
          </td>
        </tr>
        <tr style="margin-top: 60px">
          <td v-for="(item, index) in certificates_img_src2" :key="'certificates_img_src2' + index">
            <div class="certificates_img2">
              <img v-if="index == 0" :src="$baseUrl + item" alt width="341px" height="243px" />
              <img v-else :src="$baseUrl + item" alt width="171px" height="243px" />
            </div>
          </td>
        </tr>
        <!-- <el-row >
          <el-col
            :span="5"
            v-for="(item, index) in intelligenceTitle"
            :key="'intelligenceTitle' + index"
          >
            <div class="intelligenceTitle">
              <div class="div-num">
                <div class="num">{{1}}</div>
                <div class="unit">项</div>
              </div>
              <div class="intelligencetitle">二类医疗器械备案凭证</div>
            </div>
          </el-col>
        </el-row>-->
      </div>

      <!-- 联系我们 -->
      <div class="contact" v-if="current_type == 2">
        <div class="contact_content">
          <img width="15px" height="19px" :src="img_src.contactphone" alt />
          <span>服务热线: 0797-5553690（转分机号8035）或 18901111100</span>
        </div>
        <div class="contact_content">
          <img width="17px" height="13px" :src="img_src.contactemail" alt />
          <span>电子邮箱：18901111100@189.cn</span>
        </div>
        <div class="contact_content">
          <img width="15px" height="19px" :src="img_src.contactaddress" alt />
          <span>公司地址：江西省赣州市章贡区八一四大道68商住楼二层</span>
        </div>
        <baidu-map class="map" :center="markerPoint" :zoom="15" :scroll-wheel-zoom="true">
          <bm-marker :position="markerPoint" :dragging="true" @click="infoWindowOpen">
            <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">
              江西玉鸿图大数据发展有限公司
              <p style="margin-top: 10px; font-size: 13px">
                江西省赣州市章贡区八一四大道68商住楼二层
              </p>
              <p v-if="false" style="margin-top: 10px; font-size: 14px">
                客服热线：400-9158-120
              </p>
            </bm-info-window>
            <!-- 缩放 -->
            <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
            <!-- 比例尺 -->
            <bm-scale></bm-scale>
          </bm-marker>
        </baidu-map>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import typebutton from "../components/typebutton.vue";
// import 'swiper/swiper-bundle.css'
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
    typebutton,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      img_src: {
        banner: "/upload-router-api/personPhoto/2024/11/13/1731483725947384333.png",
        contentbg: "/upload-router-api/personPhoto/2024/11/13/1731480866050230658.png",
        contactaddress: "/static/images/abouts/tinified/contactaddress.png",
        contactphone: "/static/images/abouts/tinified/contactphone.png",
        contactemail: "/static/images/abouts/tinified/contactemail.png",
      },
      show: true,
      // 坐标
      markerPoint: {
        // lng: 114.996536,
        // lat: 25.840366,

        lng: 114.960455,
        lat: 25.838254,
      },
      typeList: [
        { title: "公司介绍" },
        { title: "企业资质" },
        { title: "联系我们" },
      ],
      //资质图片
      certificates_img_src1: [
        "/upload-router-api/personPhoto/2024/11/12/1731394139281969822.png",
        "/upload-router-api/personPhoto/2024/11/12/1731394155937285255.png",
        "/upload-router-api/personPhoto/2024/11/12/1731394169844735936.png",
        "/upload-router-api/personPhoto/2024/11/12/1731394184694603395.png",
        "/upload-router-api/personPhoto/2024/11/12/1731394198578593021.png",
        "/upload-router-api/personPhoto/2024/11/12/1731394210731447190.png",
      ],
      //资质图片2
      certificates_img_src2: [
        "/upload-router-api/personPhoto/2024/11/12/1731394226012886742.png",
        "/upload-router-api/personPhoto/2024/11/12/1731394243523837211.png",
        "/upload-router-api/personPhoto/2024/11/12/1731394258947769296.png",
        "/upload-router-api/personPhoto/2024/11/12/1731394282022013075.png",
        "/upload-router-api/personPhoto/2024/11/12/1731394295412965459.png",
      ],

      //资质
      intelligenceTitleList: [
        {
          title: "互联网药品信息资格证",
          num: "1",
        },
        {
          title: "发明专利及实用新型专利",
          num: "8",
        },

        {
          title: "二类医疗器械备案凭证",
          num: "1",
        },

        {
          title: "软件著作权登记",
          num: "6",
        },

        {
          title: "对外贸易经营备案凭证",
          num: "1",
        },
      ],
      current_type: 0,
    };
  },
  watch: {
    "$route.query.current_type": {
      handler: function (option, data) {
        console.log(option);
        console.log(data);
        // console.log('222222222222222');
        this.current_type = Number(this.$route.query.current_type);
        //do something
      },
    },
  },
  created() {
    this.current_type = Number(this.$route.query.current_type)
      ? Number(this.$route.query.current_type)
      : 0;
  },

  methods: {
    checkType(index) {
      this.current_type = index;
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      this.show = true;
    },
  },
};
</script>

<style lang="less" scope>
// .about_box {
.banner {
  min-width: 1200px;
  margin-bottom: 30px;
  position: relative;

  .bannerimg {
    width: 100%;
    height: 500px;
  }

  .top {
    position: absolute;
    top: 262px;
    left: 423px;
    color: #fff;

    .title {
      font-size: 48px;
      line-height: 12px;
      color: #ffffff;
    }

    .titleSc {
      font-size: 28px;
      line-height: 12px;
      color: #ffffff;
      margin-top: 60px;
    }
  }
}

// 内容
.about_content {
  width: 100%;
  margin-bottom: 40px;
  //文章标题样式

  // 公司介绍
  .introduce {
    padding-top: 40px;
    width: 900px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;

    .title {
      color: #333333;
      margin: 34px 0 10px 30px;
      font-size: 20px;
      font-weight: bold;
    }

    p {
      color: #333333;
      font-size: 16px;
      line-height: 30px;
    }
  }

  // 公司资质
  .intelligence {
    padding-top: 50px;
    width: 900px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    .intelligenceTitle:hover {
      border: 4px solid #2525cc;
    }

    .intelligenceTitle {
      display: flex;
      cursor: pointer;
      width: 170px;
      margin-left: 30px;
      height: 170px;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border: 1px solid #cfcfcf;
      color: #333333;
      font-size: 14px;
    }

    .certificates_img {
      margin-left: 30px;
    }

    .certificates_img2 {
      margin-left: 40px;
    }

    .div-num {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      color: #2525cc;

      .num {
        font-size: 60px;
      }

      .unit {
        margin-bottom: 12px;
        font-size: 22px;
      }
    }
  }

  // 联系我们
  .contact {
    padding-top: 30px;
    width: 900px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;

    .contact_content {
      margin-left: 40px;
      flex: 1;
      color: #333333;
      font-size: 14px;
      display: flex;
      align-items: center;
      margin-top: 20px;

      span {
        margin-left: 15px;
      }
    }

    .map {
      margin-top: 50px;
      height: 424px;
    }
  }
}

// }</style>



// WEBPACK FOOTER //
// src/views/Abouts.vue